import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';

const SEKELETON =
	`<ul class="lp-skeleton-animation">
		<li style="width:100%"></li>
		<li style="width:100%"></li>
		<li style="width:100%"></li>
		<li style="width:100%"></li>
		<li style="width:100%"></li>
	</ul>`;

export default function ArchiveCourse() {
	if (! document.querySelectorAll( '.thim-ekits-archive-course__skeleton' ).length) {
		return;
	}

	const elements = document.querySelectorAll( '.thim-ekits-archive-course' );

	async function getResponse( ele, params ) {
		const courseEle = ele.querySelector( '.thim-ekits-course__inner' );
		const resultCount = ele.querySelector( '.thim-ekits-archive-course__topbar__result' );
		const paginationEle = ele.querySelectorAll( '.thim-ekits-archive-course__pagination' );

		courseEle.insertAdjacentHTML( 'beforebegin', SEKELETON );
		courseEle.innerHTML = '';

		try {
			const response = await apiFetch( {
				method: 'POST',
				path: 'thim-ekit/archive-course/get-courses',
				data: { ...params },
			} );

			if (response.status === 'error') {
				throw new Error( response.message );
			}

			paginationEle && paginationEle.forEach( ( pagination ) => {
				pagination.remove();
			} );

			courseEle.innerHTML = response.data?.courses || '';
			courseEle.insertAdjacentHTML( 'afterend', response.data?.pagination || '' );
			resultCount && ( resultCount.textContent = response.data?.result_count || '' );

			pagination( ele, { ...params, paged: response.data?.page || 1 } );
		} catch (error) {
			courseEle.insertAdjacentHTML( 'beforebegin', `<div>${ error.message || 'Error when run ajax' }</div>` );
		} finally {
			const skeletons = ele.querySelectorAll( '.lp-skeleton-animation' );
			[ ...skeletons ].map( ( ele ) => ele.remove() );
		}
	}

	function pagination( ele, params ) {
		const paginationEle = ele.querySelectorAll( '.thim-ekits-archive-course__pagination' );

		paginationEle.forEach( ( elePav ) => {
			const paginations = elePav.querySelectorAll( 'a.page-numbers' );

			paginations.forEach( ( pagination ) => {
				pagination && pagination.addEventListener( 'click', ( e ) => {
					e.preventDefault();

					let page = params.page;
					if (pagination.classList.contains( 'prev' )) {
						page = params.page - 1;
					} else if (pagination.classList.contains( 'next' )) {
						page = params.page + 1;
					} else {
						page = parseInt( pagination.textContent.replace( /\D/g, '' ) );
					}

					getResponse( ele, { ...params, paged: page } );
				} );
			} );
		} );
	}

	function orderby( ele, params ) {
		const orderby = ele.querySelector( 'select[name="order_by"]' );

		orderby && orderby.addEventListener( 'change', ( e ) => {
			getResponse( ele, { ...params, orderby: orderby.value, params_url: lpData.urlParams } );
		} );
	}

	if ('IntersectionObserver' in window) {
		const eleObserver = new IntersectionObserver( ( entries, observer ) => {
			entries.forEach( ( entry ) => {
				if (entry.isIntersecting) {
					const ele = entry.target;

					if (ele.dataset.atts) {
						getResponse( ele, { atts: ele.dataset.atts, params_url: lpData.urlParams }, true );

						//orderby( ele, { atts: ele.dataset.atts } );
					}

					eleObserver.unobserve( ele );
				}
			} );
		} );

		[ ...elements ].map( ( ele ) => eleObserver.observe( ele ) );
	}
}
